import type { Route } from "./+types/public.layout";

import { Outlet, redirect } from "react-router";

import { getAuthContext } from "../lib/auth-context.server";

export async function loader({ request }: Route.LoaderArgs) {
  const ctx = await getAuthContext(request);
  if (ctx.user) {
    throw redirect("/dashboard");
  }
  return {};
}

export default function PublicLayout() {
  return <Outlet />;
}
